import { InjectionToken } from '@angular/core';

/**
 * The canonical origin this payment app is served from for the current
 * environment (e.g. https://p-staging.kody.com). Used to recognise a
 * return_url that points at our own hosted completion page.
 */
export const PAYMENT_APP_ORIGIN = new InjectionToken<string>('Payment app canonical origin');
